// extracted by mini-css-extract-plugin
export default {"container":"Search_container__CvIk8","form":"Search_form__atLog","input":"Search_input__Z56M8","button":"Search_button__XU+mM","errorMessage":"Search_errorMessage__9xZQ9"};